// src/views/Configuracion/Puestos/Puestos.tsx
import React, { useState, useEffect } from 'react';
import Table from './components/Table';
import { getPuestosByLocalId, DeletePuestosSelected } from '../../../../crud/management_api/puestos';
import { Puestos } from '../types';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import { getWorkstationsOptions, WorkstationOption } from './components/RenderFunctions';
import FilterBar from './components/FilterBar/FilterBar';
import { getPermissionState } from '../../../../utils/functions';
import { toast } from 'react-toastify';
import { MPPageTitle } from '../../../../components/ui';


const Puesto: React.FC = () => {
  const [puestos, setPuestos] = useState<Puestos[]>([]);
  const [loading, setLoading] = useState(true);
  const [filteredPuestos, setFilteredPuestos] = useState<Puestos[]>([]);
  const [workstations, setWorkstations] = useState<WorkstationOption[]>([]);
  const [searchValue, setSearchValue] = useState('');
  const [showSelection, setShowSelection] = useState(false);
  const [selectedPuestos, setSelectedPuestos] = useState<Set<string>>(new Set());
  const [showCreateModal, setShowCreateModal] = useState(false);

  const canCreate = getPermissionState(44);


  useEffect(() => {
    const fetchData = async () => {
      const fetchedWorkstations = await getWorkstationsOptions();
      
      setWorkstations(fetchedWorkstations);
    };
    
    fetchData();
  }, []);


  useEffect(() => {
    const userContext = localStorage.getItem('user');
    const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
    getPuestosByLocalId(localId)
      .then(response => {
        setPuestos(response.data);
        setFilteredPuestos(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching Puestos:", error);
        setLoading(false);
      });
  }, []);

  // Sincroniza filteredPuestos cuando puestos cambia y aplica búsqueda
  useEffect(() => {
    let filtered = puestos;
    
    if (searchValue.trim()) {
      const searchLower = searchValue.toLowerCase();
      filtered = filtered.filter((puesto) => 
        puesto.puesto_name.toLowerCase().includes(searchLower)
      );
    }
    
    setFilteredPuestos(filtered);
  }, [puestos, searchValue]);

  const handleDeleteSelection = async () => {
    if (selectedPuestos.size === 0) {
      toast.error('Debe seleccionar al menos un puesto para eliminar');
      return;
    }
    const ids = Array.from(selectedPuestos);
    try {
      await DeletePuestosSelected(ids);
      toast.success('Puestos eliminados con éxito');
      setPuestos(prev => prev.filter(p => !ids.includes(p.puesto_id)));
      setSelectedPuestos(new Set());
    } catch (error) {
      console.error(error);
      toast.error('Error al eliminar los puestos');
    }
  };

  if (loading) {
    return <LoadingSpinner text='Cargando puestos...' transparent={true}/>;
  }

  return (
    <div className="flex flex-col gap-4 p-3 pb-6 lg:gap-5 lg:p-4 lg:pb-8">
      <MPPageTitle>Puestos de trabajo</MPPageTitle>
      <FilterBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        showSelection={showSelection}
        selectedCount={selectedPuestos.size}
        onToggleSelection={() => {
          if (showSelection) {
            setSelectedPuestos(new Set());
          }
          setShowSelection(!showSelection);
        }}
        onCreatePuesto={() => setShowCreateModal(true)}
        onDeleteSelection={showSelection && selectedPuestos.size > 0 ? handleDeleteSelection : undefined}
        canCreate={canCreate}
      />
      <Table
        puestos={filteredPuestos}
        workstations={workstations}
        setPuestos={setPuestos}
        showSelection={showSelection}
        selectedPuestos={selectedPuestos}
        setSelectedPuestos={setSelectedPuestos}
        showCreateModal={showCreateModal}
        setShowCreateModal={setShowCreateModal}
      />
    </div>
  );
};

export default Puesto;
